import React from 'react';

import './styles/Checkbox.scss';

export default ({ label, isDisabled, ...restProps }) => (
  <label
    className={`custom-generic-checkbox mb-2 mb-sm-0 ${
      isDisabled ? 'disable-me' : ''
    }`}
  >
    <input {...restProps} type="checkbox" />

    <span className={isDisabled ? 'checkmark-disabled' : 'checkmark'}></span>

    {label && <span className="check-box-label">{label}</span>}
  </label>
);
